import { render } from "./Sv060.vue?vue&type=template&id=14a5ac86&scoped=true"
import script from "./Sv060.vue?vue&type=script&lang=js"
export * from "./Sv060.vue?vue&type=script&lang=js"

import "./Sv060.vue?vue&type=style&index=0&id=14a5ac86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a5ac86"]])

export default __exports__